import moment from 'moment';
import { useRouter } from 'next/router';

const SidebarRight = ({ value, date, currentTime, handleChangeTime }) => {
  const router = useRouter();

  return (
    <div>
      {value === currentTime ? (
        <button
          className="btn date-btn p-10 w-100 br-50 btn-active"
          onClick={() => handleChangeTime(value)}
        >
          <p className="color-light-blue">{value}</p>
        </button>
      ) : (
        <button
          className="btn date-btn p-10 w-100 br-50"
          onClick={() => handleChangeTime(value)}
        >
          <p>{value}</p>
        </button>
      )}
    </div>
  );
};

export default SidebarRight;
